module.exports = __webpack_public_path__ + "img/beijing.8ddcfe7d.png";